// Adresse à partager (QR code « Partager ») : localhost n'est pas joignable depuis un autre appareil.
// En développement, Vite fournit l'adresse du poste sur le réseau local (voir vite.config.js) ;
// on la substitue alors à localhost, en gardant le chemin et les paramètres de la page.

/** Le jeu est-il ouvert sur une adresse propre à ce poste (localhost, 127.0.0.1, ::1) ? */
export function isLocalhostUrl(href) {
  const { hostname } = new URL(href);
  return hostname === 'localhost' || hostname.endsWith('.localhost')
    || hostname === '127.0.0.1' || hostname === '[::1]';
}

/**
 * @param {string} href     adresse courante de la page
 * @param {string} [lanUrl] adresse réseau local du serveur de dev, si connue
 * @returns {string} l'adresse à mettre dans le QR code
 */
export function resolveShareUrl(href, lanUrl) {
  if (!lanUrl || !isLocalhostUrl(href)) return href;
  const { pathname, search, hash } = new URL(href);
  return new URL(pathname + search + hash, lanUrl).href;
}
